
const projectListMoudle={
  namespaced: true,
  state:{
    searchSN:null,
    model:null,
    projectName:null,
    projectIds:[],
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default projectListMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/projectList.js